import { useTranslation } from 'react-i18next';

interface InstructionsListProps {
  titleKey: string;
  simpleStepsKey?: string; // key of array of strings in translation file
  numberedStepsKey?: string; // key of array of strings in translation file
  className?: string;
}

export function InstructionsList({
  titleKey,
  simpleStepsKey,
  numberedStepsKey,
  className = '',
}: InstructionsListProps) {
  const { t } = useTranslation();

  const simpleSteps = simpleStepsKey
    ? (t(simpleStepsKey, { returnObjects: true }) as string[] | string)
    : null;

  const numberedSteps = numberedStepsKey
    ? (t(numberedStepsKey, { returnObjects: true }) as string[] | string)
    : null;

  const simpleStepsList = Array.isArray(simpleSteps) ? simpleSteps : [];
  const numberedStepsList = Array.isArray(numberedSteps) ? numberedSteps : [];

  return (
    <div
      className={`w-full bg-secondary-bg dark:bg-muted rounded-[1.6rem] px-[2.4rem] py-[1.6rem] space-y-[0.8rem] ${className}`}>
      <h4 className="headline4 text-foreground">{t(titleKey)}</h4>
      <div className="space-y-0">
        {simpleStepsList.map((step, index) => (
          <p key={`simple-${index}`} className="p3 text-foreground">
            {step}
          </p>
        ))}

        {numberedStepsList.length > 0 && (
          <ol>
            {numberedStepsList.map((step, index) => (
              <li key={`numbered-${index}`} className="p3 text-foreground flex">
                <span className="p3 text-foreground mr-[0.4rem]">
                  {index + 1}.
                </span>
                <span>{step}</span>
              </li>
            ))}
          </ol>
        )}
      </div>
    </div>
  );
}
